/**
 * @description 路由守卫，目前两种模式：all模式与intelligence模式
 */
import { useUserStore } from '@/store/modules/user'
import { watch } from 'vue'
import { useRoutesStore } from '@/store/modules/routes'
import { useSettingsStore } from '@/store/modules/settings'
import VabProgress from 'nprogress'
import 'nprogress/nprogress.css'
import getPageTitle from '@/utils/pageTitle'
import { toLoginRoute } from '@/utils/routes'
import {
  authentication,
  loginInterception,
  routesWhiteList,
  supportVisit,
} from '@/config'

export function setupPermissions(router) {
  watch(
    () => getPageTitle(router.currentRoute.value.meta.title),
    (title) => {
      document.title = title
    },
    { immediate: true }
  )
  VabProgress.configure({
    easing: 'ease',
    speed: 500,
    trickleSpeed: 200,
    showSpinner: false,
  })
  router.beforeEach(async (to, from, next) => {
    // let areaData = JSON.parse(localStorage.getItem('area'))
    // if (!areaData) {
    //   const { data: areaList } = await commonRegion()
    //   localStorage.setItem('area', JSON.stringify(areaList))
    // }
    const {
      getTheme: { showProgressBar },
    } = useSettingsStore()
    const { routes, setRoutes } = useRoutesStore()
    const { token, getUserInfo, setVirtualRoles, resetAll } = useUserStore()

    if (showProgressBar) VabProgress.start()

    let hasToken = token
    // console.log(22, loginInterception, hasToken, routes)
    if (!loginInterception) hasToken = true

    if (hasToken) {
      if (routes.length) {
        // console.log(33, to.path, showProgressBar)
        // 禁止已登录用户返回登录页
        if (to.path === '/login') {
          next({ path: '/' })
          if (showProgressBar) VabProgress.done()
        } else next()
      } else {
        try {
          if (loginInterception) await getUserInfo()
          // config/setting.config.js loginInterception为false(关闭登录拦截时)时，创建虚拟角色
          else await setVirtualRoles()
          // 根据路由模式获取路由并根据权限过滤
          await setRoutes(authentication)
          next({ ...to, replace: true })
        } catch (err) {
          console.error('错误拦截:', err)
          await resetAll()
          next(toLoginRoute(to.path))
        }
      }
    } else {
      console.log('to', to)
      if (routesWhiteList.includes(to.path)) {
        if (showProgressBar) VabProgress.done()
        if (supportVisit && !routes.length) {
          next({ path: to.path, replace: true })
        } else next()
      } else next(toLoginRoute(to.path))
    }
  })
  router.afterEach(() => {
    if (VabProgress.status) VabProgress.done()
  })
}
